import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Converts **bold** markdown to <strong> elements. Only supports **.
 */ function markdownBold(text) {
    const parts = text.split(/\*\*(.+?)\*\*/g);
    return parts.map((part, i)=>i % 2 === 1 ? /*#__PURE__*/ _jsx("strong", {
            children: part
        }, i) : part);
}
export { markdownBold };
